// eslint-disable-next-line no-restricted-imports
import {
  RoleFragment,
  Query_UserController_GetList_AllOf_1_List_Items_Role_Name as RoleTypeApi,
} from 'api/generated/graphql';
import { PermissionType, RoleType, UserRoleEntity } from 'api/types/entity';
import { lodash } from 'helpers';

const roles: Record<RoleTypeApi, RoleType> = {
  [RoleTypeApi.Admin]: RoleType.Admin,
  [RoleTypeApi.Superadmin]: RoleType.Superadmin,
  [RoleTypeApi.BackOffice]: RoleType.BackOffice,
  [RoleTypeApi.ComplianceOfficer]: RoleType.ComplianceOfficer,
  [RoleTypeApi.LegalOfficer]: RoleType.LegalOfficer,
  [RoleTypeApi.MiddleOffice]: RoleType.MiddleOffice,
  [RoleTypeApi.RiskManager]: RoleType.RiskManager,
  [RoleTypeApi.FrontOffice]: RoleType.FrontOffice,
  [RoleTypeApi.SettlementSpecialist]: RoleType.SettlementSpecialist,
};

export const parseUserRoleEntity = (role: RoleFragment): UserRoleEntity => ({
  name: roles[role.name],
  permissions: lodash
    .compact(role.permissions!)
    .map(({ name }) => PermissionType[name]),
});
